import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-solvup',
  templateUrl: './invoice-solvup.component.html',
  styleUrls: ['./invoice-solvup.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceSolvupComponent extends InvoiceComponent implements OnInit {
  @Input()
  invoice: InvoiceInterface;

  prefillLineItems = [
    {
      item: "Minimum Assessment Fee",
      desc: "Quote Rejected",
      price: 9900,
      qty: 1
    },
    {
      item: "Return Freight",
      desc: "",
      price: 1500,
      qty: 1
    },
    {
      item: "Return Freight",
      desc: "",
      price: 1500,
      qty: 1
    }
  ]

  defaultInvoice = {
    type: "solvup",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-solvup"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
